/** 11sight aded packages BEGIN */
import { withStyles } from '@mui/styles';
import * as IISightAPI from 'common/helpers/api';
import { ChatInput as JitsiChatInput, mapStateToProps, } from 'jitsi/chat/components/web/ChatInput';
/** 11sight aded packages END */
import QuickRepliesDialog from './QuickRepliesDialog';
import React from 'react';
import { connect } from 'react-redux';
import { random } from 'lodash';
import { translate } from 'jitsi/base/i18n/functions';
import Input from 'jitsi/base/ui/components/web/Input';
import SmileysPanel from './SmileysPanel';
import cx from 'clsx';
import { showErrorNotification } from 'jitsi/notifications/actions';
import { NOTIFICATION_TIMEOUT_TYPE } from 'jitsi/notifications/constants';
import { Slide } from './uploadingCarousel/Slide';
import { Carousel } from 'features/base/ui/components/Carousel';
import { Attachment } from './attachments';
// 11sight lines added END
const styles = (theme) => {
    return {
        container: {
            boxSizing: 'border-box',
            marginTop: theme.spacing(2),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch !important',
            position: 'relative',
            background: '#FFF',
        },
        chatInput: {
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
        },
        iconsRow: {
            display: 'flex',
            alignItems: 'center',
            padding: '16px 16px',
            gap: '16px',
            alignSelf: 'stretch',
            boxShadow: '0 2px 0 0 #F1F3F4 inset !important',
        },
        inputRow: {
            display: 'flex',
            alignItems: 'center',
            padding: '16px',
            gap: '8px',
            alignSelf: 'stretch',
            boxShadow: '0 2px 0 0 #F1F3F4 inset !important',
        },
        inputContainer: {
            flex: 1,
        },
        chatTextArea: {
            border: 'none !important',
            boxShadow: 'none !important',
            outline: 'none !important',
            '& textarea': {
                background: 'none',
                color: '#4B4B4B !important',
                border: 'none !important',
                outline: 'none !important',
                boxShadow: 'none !important',
                padding: '0 !important',
                fontFamily: '"Nunito Sans" !important',
                fontSize: '16px !important',
                fontWeight: '600 !important',
                lineHeight: '24px !important',
                '&::placeholder': {
                    color: '#ACACAC !important',
                    opacity: '1 !important',
                    fontFamily: '"Nunito Sans" !important',
                    fontSize: '16px !important',
                    fontWeight: '600 !important',
                    lineHeight: '24px !important',
                },
                '&:focus': {
                    outline: 'none !important',
                    border: 'none !important',
                    boxShadow: 'none !important',
                },
                '&:active': {
                    outline: 'none !important',
                    border: 'none !important',
                    boxShadow: 'none !important',
                }
            },
            '&:focus-within': {
                border: 'none !important',
                boxShadow: 'none !important',
                outline: 'none !important',
            }
        },
        carouselContainer: {
            width: '100%',
            padding: `${theme.spacing(2)} 0`,
            border: 'none',
        },
        leftIcons: {
            display: 'flex',
            alignItems: 'center',
        },
        icon: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '& svg, & path': {
                transition: 'fill 0.2s, stroke 0.2s',
            },
            '&:hover': {
                background: 'white !important',
                '& svg, & path': {
                // Let icons change color on hover naturally or via state
                },
            },
            '&:disabled': {
                background: 'none',
                '& svg, & path': {
                    fill: theme.palette.iisightGray400,
                },
            },
        },
        sendButton: {
        // Allow inline fill to dominate
        },
        activeIcon: {
            '& svg, & path': {
                stroke: `${theme.palette.iisightBrand} !important`,
            },
        },
        smileysContainer: {
            width: '100%',
            margin: 0,
            backgroundColor: 'initial !important',
            overflow: 'visible',
        },
        smileysInput: {
            width: '100%',
        },
        hiddenInput: {
            position: 'absolute',
            width: 0,
            height: 0,
            padding: 0,
            margin: -1,
            overflow: 'hidden',
            clip: 'rect(0,0,0,0)',
            border: 0,
            visibility: 'hidden',
        },
    };
};
/**
 * Implements a React Component for drafting and submitting a chat message.
 *
 * @augments Component
 */
class ChatInput extends JitsiChatInput {
    state = {
        message: '',
        showSmileysPanel: false,
        // 11sight added lines BEGIN
        blockedFileExtensions: [],
        files: [],
        showQuickReplies: false,
        // 11sight added lines END
    };
    /** 11sight added lines BEGIN */
    _fileInput;
    /** 11sight added lines END */
    /**
     * Initializes a new {@code ChatInput} instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this._textArea = React.createRef();
        /** 11sight added lines BEGIN */
        this._fileInput = React.createRef();
        this._onAttachmentClick = this._onAttachmentClick.bind(this);
        /** 11sight added lines END */
        this.removeFile = this.removeFile.bind(this);
        this._onFileChange = this._onFileChange.bind(this);
        this.onUploadError = this.onUploadError.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this._toggleQuickRepliesPanel = this._toggleQuickRepliesPanel.bind(this);
        this._onQuickReplySelect = this._onQuickReplySelect.bind(this);
    }
    // 11sight lines added BEGIN
    /**
     * Loads black listed file extensions from the API.
     *
     * @returns {void}
     */
    async getFileExtensions() {
        try {
            const { data } = await IISightAPI.getBlockedExtension();
            this.setState({ blockedFileExtensions: data });
        }
        catch { }
    }
    componentDidMount() {
        this.getFileExtensions();
    }
    /**
     * Trigerred when new file is selected.
     *
     * @param {Object} event - File event.
     * @returns {void}
     */
    _onFileChange(event) {
        const { files: rawFiles } = event.target;
        const files = [...(rawFiles || [])];
        event.target.form?.reset();
        if (!this.state.blockedFileExtensions)
            return this.props.dispatch(showErrorNotification({ titleKey: 'notify.UnexpectedErrorHappened' }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
        let errored = false;
        files.forEach((file) => {
            const { name } = file;
            const parts = name.split('.');
            const extension = parts[parts.length - 1];
            if (extension && this.state.blockedFileExtensions.includes(extension)) {
                errored = true;
                this.props.dispatch(showErrorNotification({ titleKey: 'notify.UnsupportedFileExtension' }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
            }
            else if (file.size > 25 * 1024 * 1024) {
                errored = true;
                this.props.dispatch(showErrorNotification({ titleKey: 'notify.UnsupportedFileSize' }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
            }
            if (errored)
                return;
            file.id = `${file.size}-${Date.now()}-${random(0, 50)}`;
        });
        if (errored)
            return;
        this.setState((state) => ({ ...state, files: [...state.files, ...files] }));
    }
    onUploadError(fileName) {
        this.props.dispatch(showErrorNotification({ titleKey: 'notify.ErrorInFileUploading' }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
        if (fileName) {
            this.setState((state) => ({
                ...state,
                files: this.state.files.map((file) => {
                    if (file.name === fileName)
                        delete file.uploading;
                    return file;
                }),
            }));
        }
    }
    async uploadFile(file) {
        this.setState((state) => ({
            ...state,
            files: state.files.map((stateFile) => {
                if (stateFile.name === file.name)
                    stateFile.uploading = true;
                return stateFile;
            }),
        }));
        const data = new FormData();
        data.append('meeting_attachment[attachment]', file);
        const response = await IISightAPI.uploadFile(data).catch(() => this.onUploadError(file.name));
        if (!response)
            return;
        this.setState((state) => ({
            ...state,
            files: state.files.filter((stateFile) => stateFile.name !== file.name),
        }));
        this.props.onSend(JSON.stringify(response.data.json.attachment));
        return response.data;
    }
    /**
     * Trigerred when file upload is started.
     *
     * @param {Object} event - File event.
     * @returns {void}
     */
    async _onSubmitMessage() {
        const message = this.state.message.trim();
        if (message) {
            await this.props.onSend(message);
            this.setState({ message: '' });
        }
        if (this.state.files.length === 0)
            return;
        const responses = await Promise.all(this.state.files.map(this.uploadFile)).catch(this.onUploadError);
        if (!responses || responses.includes(undefined))
            return;
        this.setState({ ...this.state, files: [] });
    }
    removeFile(fileIndex) {
        this.setState((state) => ({
            ...state,
            files: state.files.filter((_, index) => index !== fileIndex),
        }));
    }
    _toggleQuickRepliesPanel() {
        this.setState((state) => ({
            ...state,
            showQuickReplies: !state.showQuickReplies,
            showSmileysPanel: false, // Close smileys if opening quick replies
        }));
    }
    async _onQuickReplySelect(content, sendImmediately = false) {
        this.setState({
            message: content,
            showQuickReplies: false,
        }, () => {
            if (sendImmediately) {
                this._onSubmitMessage();
            }
            else if (this._textArea.current) {
                this._textArea.current.focus();
            }
        });
    }
    _onAttachmentClick() {
        if (this._fileInput.current) {
            this._fileInput.current.click();
        }
    }
    // 11sight lines added END
    render() {
        const { classes, _areSmileysDisabled, t } = this.props;
        const attachmentClassName = `${'enableAttachmentIcon'}`;
        return (React.createElement("form", { className: classes.container, id: 'chat-input' },
            !_areSmileysDisabled && this.state.showSmileysPanel && (React.createElement("div", { className: cx('smiley-input', classes.smileysInput) },
                React.createElement("div", { className: cx('smileys-panel', classes.smileysContainer) },
                    React.createElement(SmileysPanel, { onSmileySelect: this._onSmileySelect })))),
            this.state.showQuickReplies && ((() => {
                return (React.createElement(QuickRepliesDialog, { categories: window.APP.room?.conference_options?.quick_reply_categories || [], onSelect: this._onQuickReplySelect }));
            })()),
            this.state.files.length !== 0 && (React.createElement("div", { className: classes.carouselContainer },
                React.createElement(Carousel, { px: 2, gap: 2 }, this.state.files.map((file, index) => {
                    return (React.createElement(Slide, { key: file.id, uploading: file.uploading, onRemove: () => this.removeFile(index) },
                        React.createElement(Attachment, { height: 60, variant: 'square', name: file.name, size: file.size, type: file.type, url: URL.createObjectURL(file) })));
                })))),
            React.createElement("div", { className: classes.chatInput },
                React.createElement("div", { className: classes.iconsRow },
                    !window.APP.room?.conference_options?.disable_file_upload && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: cx(classes.icon, attachmentClassName), onClick: this._onAttachmentClick, role: 'button', "aria-label": t('chat.attachFiles'), style: { cursor: 'pointer', display: 'flex', alignItems: 'center' } },
                            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
                                React.createElement("path", { d: "M9.05136 14.7112C9.05136 14.7112 9.39099 14.3576 14.7778 8.97079C14.8622 8.88742 14.9291 8.78814 14.9748 8.67871C15.0205 8.56928 15.0441 8.45187 15.0441 8.33328C15.0441 8.21469 15.0205 8.09727 14.9748 7.98784C14.9291 7.87841 14.8622 7.77913 14.7778 7.69576C14.6105 7.52984 14.3844 7.43674 14.1487 7.43674C13.913 7.43674 13.6869 7.52984 13.5195 7.69576L7.77911 13.439C7.27188 13.9451 6.98647 14.632 6.98569 15.3485C6.98491 16.0651 7.26881 16.7526 7.77494 17.2599C8.28107 17.7671 8.96797 18.0525 9.68453 18.0533C10.4011 18.0541 11.0886 17.7702 11.5958 17.264L19.2293 9.62222C20.048 8.77359 20.5007 7.63746 20.4901 6.45836C20.4795 5.27926 20.0064 4.15145 19.1726 3.31766C18.3389 2.48388 17.2111 2.01078 16.032 2.00018C14.8529 1.98959 13.7167 2.44234 12.8681 3.26101L4.85323 11.2759L4.83653 11.2926C3.66036 12.4691 2.99974 14.0647 3 15.7283C3.00026 17.3919 3.66138 18.9873 4.83792 20.1635C6.01446 21.3396 7.61004 22.0003 9.27366 22C10.9373 21.9997 12.5327 21.3386 13.7088 20.1621L13.7227 20.1454L18.5612 15.3153C18.6445 15.2325 18.7106 15.134 18.7558 15.0256C18.8009 14.9171 18.8241 14.8008 18.8241 14.6834C18.8241 14.5659 18.8009 14.4496 18.7558 14.3411C18.7106 14.2327 18.6445 14.1342 18.5612 14.0514C18.3932 13.8845 18.166 13.7908 17.9292 13.7908C17.6924 13.7908 17.4652 13.8845 17.2973 14.0514L12.4505 18.8731L12.4338 18.8898C12.0222 19.3215 11.5284 19.6665 10.9815 19.9045C10.4346 20.1425 9.84568 20.2688 9.24928 20.2759C8.65288 20.283 8.06109 20.1707 7.5087 19.9457C6.95631 19.7208 6.45449 19.3876 6.03274 18.9659C5.61099 18.5441 5.27783 18.0423 5.05286 17.4899C4.82789 16.9375 4.71565 16.3457 4.72273 15.7493C4.72981 15.1529 4.85608 14.564 5.09411 14.0171C5.33214 13.4702 5.67713 12.9764 6.10877 12.5648L6.12548 12.5481L14.1403 4.53325C14.6472 4.02712 15.3344 3.74307 16.0507 3.74359C16.767 3.74412 17.4537 4.02917 17.9598 4.53603C18.466 5.0429 18.75 5.73007 18.7495 6.44637C18.749 7.16267 18.4639 7.84942 17.9571 8.35555L10.3236 15.9807C10.2414 16.0691 10.1422 16.1402 10.0319 16.1895C9.92168 16.2388 9.80261 16.2654 9.68185 16.2677C9.56109 16.27 9.4411 16.2479 9.32905 16.2028C9.217 16.1577 9.11519 16.0905 9.02969 16.0052C8.94419 15.9198 8.87675 15.8182 8.8314 15.7062C8.78606 15.5943 8.76373 15.4743 8.76575 15.3536C8.76777 15.2328 8.7941 15.1137 8.84317 15.0033C8.89224 14.893 8.96305 14.7936 9.05136 14.7112Z", fill: "#6F6F6F" }))),
                        React.createElement("input", { className: classes.hiddenInput, ref: this._fileInput, onChange: this._onFileChange, type: 'file', multiple: true }))),
                    React.createElement("div", { className: cx(classes.icon, { [classes.activeIcon]: this.state.showSmileysPanel }), onClick: this._toggleSmileysPanel, role: 'button', "aria-label": t('chat.smileysPanel'), style: { cursor: 'pointer', display: 'flex', alignItems: 'center' } },
                        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
                            React.createElement("path", { d: "M15.5 11C15.9167 11 16.2708 10.8542 16.5625 10.5625C16.8542 10.2708 17 9.91667 17 9.5C17 9.08333 16.8542 8.72917 16.5625 8.4375C16.2708 8.14583 15.9167 8 15.5 8C15.0833 8 14.7292 8.14583 14.4375 8.4375C14.1458 8.72917 14 9.08333 14 9.5C14 9.91667 14.1458 10.2708 14.4375 10.5625C14.7292 10.8542 15.0833 11 15.5 11ZM8.5 11C8.91667 11 9.27083 10.8542 9.5625 10.5625C9.85417 10.2708 10 9.91667 10 9.5C10 9.08333 9.85417 8.72917 9.5625 8.4375C9.27083 8.14583 8.91667 8 8.5 8C8.08333 8 7.72917 8.14583 7.4375 8.4375C7.14583 8.72917 7 9.08333 7 9.5C7 9.91667 7.14583 10.2708 7.4375 10.5625C7.72917 10.8542 8.08333 11 8.5 11ZM12 17.5C13.1333 17.5 14.1625 17.1792 15.0875 16.5375C16.0125 15.8958 16.6833 15.05 17.1 14H6.9C7.31667 15.05 7.9875 15.8958 8.9125 16.5375C9.8375 17.1792 10.8667 17.5 12 17.5ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z", fill: "#6F6F6F" }))),
                    ((window.APP.room?.conference_options?.quick_reply_categories?.length || 0) > 0 && !window.APP.room?.vconnectCaller) && (React.createElement("div", { className: cx(classes.icon), onClick: this._toggleQuickRepliesPanel, role: 'button', "aria-label": t('chat.quickReplies'), style: {
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            height: '24px',
                            flexShrink: 0,
                            alignSelf: 'stretch'
                        } },
                        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
                            React.createElement("path", { d: "M15 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V7L15 2Z", stroke: this.state.showQuickReplies ? "#4DA648" : "#6F6F6F", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
                            React.createElement("path", { d: "M14 2V6C14 6.53043 14.2107 7.03914 14.5858 7.41421C14.9609 7.78929 15.4696 8 16 8H20", stroke: this.state.showQuickReplies ? "#4DA648" : "#6F6F6F", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
                            React.createElement("path", { d: "M10 9H8", stroke: this.state.showQuickReplies ? "#4DA648" : "#6F6F6F", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
                            React.createElement("path", { d: "M16 13H8", stroke: this.state.showQuickReplies ? "#4DA648" : "#6F6F6F", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
                            React.createElement("path", { d: "M16 17H8", stroke: this.state.showQuickReplies ? "#4DA648" : "#6F6F6F", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))))),
                React.createElement("div", { className: classes.inputRow },
                    React.createElement("div", { className: classes.inputContainer },
                        React.createElement(Input, { className: classes.chatTextArea, id: 'chat-input-messagebox', maxRows: 5, onChange: this._onMessageChange, onKeyPress: this._onDetectSubmit, placeholder: 'Write a message here...', ref: this._textArea, textarea: true, value: this.state.message })),
                    React.createElement("div", null,
                        React.createElement("div", { className: cx(classes.icon, classes.sendButton), onClick: this._onSubmitMessage, role: 'button', "aria-label": t('chat.sendButton'), style: { cursor: 'pointer', display: 'flex', alignItems: 'center' } },
                            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "26", height: "24", viewBox: "0 0 26 24", fill: "none" },
                                React.createElement("g", { filter: "url(#filter0_d_send)" },
                                    React.createElement("path", { d: "M2.01611 21V14.016L17.0161 12L2.01611 9.984V3L23.0161 12L2.01611 21Z", fill: (this.state.message.trim() || this.state.files.length > 0) ? "#4DA648" : "#ACACAC" })),
                                React.createElement("defs", null,
                                    React.createElement("filter", { id: "filter0_d_send", x: "-2", y: "-1", width: "28", height: "28", filterUnits: "userSpaceOnUse", "color-interpolation-filters": "sRGB" },
                                        React.createElement("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }),
                                        React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                                        React.createElement("feOffset", { dy: "1" }),
                                        React.createElement("feGaussianBlur", { stdDeviation: "1" }),
                                        React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0" }),
                                        React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_send" }),
                                        React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_send", result: "shape" }))))))))));
    }
}
export default withStyles(styles)(translate(connect(mapStateToProps)(ChatInput)));
